import {
  Breadcrumb,
  Button,
  Card,
  DatePicker,
  Form,
  Input,
  Modal,
  Radio,
  Select,
} from "antd";
import React, { useState, useCallback, useEffect } from "react";
import { useNavigate } from "react-router";
import SendMoneyService from "../../../services/send-money.service";
import { NumericFormat } from "react-number-format";
import {
  allowDecimalwithMaxLimit,
  allowOnlyAlphaNumerics,
  allowOnlyAlphaNumericsWithSpace,
  allowOnlyAlphabetsWithSpace,
  allowOnlyNumbers,
  amountFormat,
  handlePasteNotAllowSpace,
} from "../../../services/common.service";
import { useDispatch, useSelector } from "react-redux";
import {
  transferAccountListSelector,
  modeSelector,
  selectedAccountSelector,
} from "../../../store/selectors/app.selector";
import TransferService from "../../../services/transfer.service";
import CommonOtp from "../../../components/otp";
import {
  setAccountList,
  setSelectedAccount,
} from "../../../store/actions/app.action";
import AccountService from "../../../services/accounts.service";
import dayjs from "dayjs";
import AccountDisplay from "../../../components/account-display";
import { CONFIG } from "../../../environment";
import checkedIcon from "../../../assests/images/checked.svg";
import unCheckedIcon from "../../../assests/icons/uncheck.png";
import { ReactComponent as TitleIcon } from "../../../assests/images/quicktbreadrans.svg";
import AccountCard from "../../../components/account-card";
import AccountSelectedCard from "../../../components/account-selected-card";
import { ReactComponent as TickIcon } from "../../../assests/images/tickIcon.svg";
import { useTranslation } from "react-i18next";
import AccountDisplayView from "../../../components/account-display-view";
import PendingAuthService from "../../../services/approvals.service";
import { VscError } from "react-icons/vsc";

export default function OwnQuickTransfer() {
  const navigate = useNavigate();
  const [stage, setStage] = useState(1);
  const [verifyDetails, setVerifyDetails] = useState({});
  const [form] = Form.useForm();
  const accountList = useSelector(transferAccountListSelector);
  const [isErrorModalVisible, setIsErrorModalVisible] = useState(false);
  const [formDetails, setFormDetails] = useState({
    addBene: false,
    hasFxDeal: false,
    paymentType: "ONCE",
    paymentSubType: "Pay_Now",
    txnCcy: "",
  });
  const [cancelVisible, setCancelVisible] = useState(false);
  const [respDetails, setRespDetails] = useState({});
  const dispatch = useDispatch();
  const mode = useSelector(modeSelector);
  const [metaData, setMetaData] = useState({
    frequency: [],
    maximumInstallments: [],
    paymentTypes: {},
    transferTypes: {},
  });
  const [paymentType, setPaymentType] = useState("ONCE");
  const [paymentSubType, setPaymentSubType] = useState("Pay_Now");
  const selectedAccount = useSelector(selectedAccountSelector);
  const [addBene, setAddBene] = useState(false);
  const [accountDetails, setAccountDetails] = useState({});
  const [convertedAmount, setConvertedAmount] = useState({});
  const [hasFxDeal, setHasFxDeal] = useState(false);
  const [selectedTxnCcy, setSelectedTxnCcy] = useState();
  const [txnCurrencyList, setTxnCurrencyList] = useState([]);
  const [otp, setOtp] = useState("");
  const [successVisible, setSuccessVisible] = useState(false);
  const { t } = useTranslation();
  const [chargesList, setChargesList] = useState([]);

  useEffect(() => {
    if (accountList?.length > 0) {
      setConvertedAmount({});
      form.resetFields(["amount"]);
      // let currencies = [selectedAccount?.accountCurrency];
      // if (
      //   Object.keys(accountDetails).length > 0 &&
      //   accountDetails?.accCcy !== selectedAccount?.accountCurrency
      // ) {
      //   currencies.unshift(accountDetails?.accCcy);
      // } else {

      //   form.setFieldsValue({ txnCcy: "" });
      // }
      // setTxnCurrencyList(currencies);
      form.setFieldsValue({ txnCcy: selectedAccount?.accountCurrency });
    }
  }, [accountList, selectedAccount, accountDetails]);

  useEffect(() => {
    transferOptions();
  }, []);

  const transferOptions = useCallback(async () => {
    try {
      const response = await SendMoneyService.transferOptions();
      if (response.status === 200) {
        setMetaData(response.data["data"]);
      }
    } catch (error) {}
  }, []);

  const onVerify = useCallback(
    async (values) => {
      try {
        const srcAccDetails = accountList.find(
          (ele) => ele.accountNo === selectedAccount.accountNo
        );

        if (CONFIG?.CROSS_CURRENCY === false) {
          if (srcAccDetails?.accountCurrency !== accountDetails?.accCcy) {
            setIsErrorModalVisible(true);
            return;
          }
        }

        const transferAmount =
          typeof values.amount === "number"
            ? values.amount
            : parseFloat(values.amount.replaceAll(/,/g, ""));

        const fxdealrates = values?.fxDealRefNo
          ? {
              fxreferencerate: convertedAmount?.convRate || "",
              isfxDealRateAvl: "Y",
            }
          : { fxreferencerate: "", isfxDealRateAvl: "N" };

        const reqParams = {
          srcAcct: srcAccDetails?.accountNo,
          accountName: srcAccDetails?.accountName,
          srcAccName: srcAccDetails?.accountName,
          srcBr: srcAccDetails?.branchId,
          srcCcy: srcAccDetails?.accountCurrency,
          destBr: accountDetails?.accBranch || CONFIG.BRANCH_NAME,
          destCcy: accountDetails?.accCcy,
          destAcct: values?.destAcctNo,
          amount: transferAmount,
          narration: values?.remarks || "",
          remarks: values?.remarks || "",
          remarksTag: values?.remarks,
          txnType: "OAT",
          quickTransfer: true,
          destBankName: CONFIG.BANK_NAME,
          destBankAddr: "",
          destBankCty: "",
          txnCcy: values?.txnCcy,
          txnDate: dayjs(new Date()),
          chargeBornesBy: "OUR",
          beneName: accountDetails?.customerName || values?.beneName,
          beneMobileNo: "",
          beneMail: "",
          beneAddr: "",
          fxDealRefNo: values?.fxDealRefNo || "",
          bicCode: "",
          sortCode: "",
          swiftCode: "",
          custId: srcAccDetails?.customerId,
          bulkTransfer: false,
          paymentType:
            paymentType === "ONCE" && paymentSubType === "Pay_Later"
              ? "SCHEDULED"
              : paymentType,
          numberOfInstallments: values?.numberOfInstallment,
          payeeId: 0,
          scheduled:
            paymentType === "ONCE" && paymentSubType === "Pay_Later"
              ? true
              : false,
          addBene: addBene,
          recurring: paymentType === "RECURRING",
          scheduledDate: values?.frequencyDate
            ? values?.frequencyDate.format("YYYY-MM-DD")
            : "",
          frequency: values?.frequency,
          customFields: {
            ...fxdealrates,
          },
        };
        setFormDetails(reqParams);
        getCharges(reqParams);
        //setStage(2);
      } catch (error) {}
    },
    [
      accountList,
      metaData,
      accountDetails,
      selectedAccount,
      addBene,
      paymentSubType,
      paymentType,
      convertedAmount,
      CONFIG,
    ]
  );

  const fundTransferVerify = useCallback(async () => {
    try {
      const req = {
        ...formDetails,
        conversionAmount: convertedAmount?.convAmt || "",
        conversionRate: convertedAmount.convRate || "",
      };
      setFormDetails(req);
      const response = await TransferService.fundTransferVerify(req);
      if (response.status === 200) {
        setVerifyDetails(response.data["data"]);
        if (response.data["data"]["otpEnabled"]) {
          setStage(3);
        } else {
          fundTransferConfirm({
            ...req,
            ...{ otp: CONFIG.DEFAULT_OTP },
          });
        }
      }
    } catch (error) {}
  }, [formDetails, convertedAmount]);

  const getCharges = useCallback(
    async (data) => {
      try {
        const req = {
          module: "FUNDTRANSFER",
          srcAcct: data.srcAcct,
          srcCcy: data.srcCcy,
          destCcy: data.destCcy,
          destAcct: data.destAcct,
          destBankName: data.destBankName,
          amount: data.amount,
          txnType: data.txnType,
          chargeBornesBy: "OUR",
          txnCcy: data.txnCcy,
        };
        const response = await AccountService.getAllCharges(req);
        if (response.status === 200) {
          setChargesList(response.data);
          console.log(response.data);
          setStage(2);
        }
      } catch (error) {}
    },
    [formDetails, convertedAmount]
  );

  const fundTransferConfirm = useCallback(async (reqParams) => {
    try {
      setFormDetails(reqParams);
      const response = await TransferService.fundTransferConfirm(reqParams);
      if (response.status === 200) {
        dispatch(setAccountList([]));
        setRespDetails({
          message: response.data?.message,
          ...response.data["data"],
        });
        setSuccessVisible(true);
      }
    } catch (error) {
      setOtp("");
      if (["TG-USR-40025", "TG-USR-40026"].indexOf(error.data.code) < 0) {
        setStage(1);
      }
    }
  }, []);

  const fetchAccounts = useCallback(async () => {
    try {
      const response = await AccountService.getQuickAccounts("BA");
      if (response.status === 200) {
        const selectedAccountDetails =
          response?.data["data"]["accounts"].find(
            (ele) => ele.primaryAccount === true
          ) ||
          response.data["data"]["accounts"][0] ||
          [];
        dispatch(setSelectedAccount(selectedAccountDetails));
      }
    } catch (error) {}
  }, []);

  const accountLookUp = useCallback(
    async (acctNo) => {
      try {
        if (
          +acctNo.length > CONFIG?.ACCOUNT_NO_MIN_LENGTH &&
          +acctNo.length <= CONFIG?.ACCOUNT_NUMBER_MAX_LENGTH
        ) {
          const reqParams = {
            transferType: "IAT",
            accountNo: acctNo,
            mobileNo: acctNo,
            bankName: "",
            custParams: {},
          };
          const response = await SendMoneyService.accountLookUp(reqParams);
          if (response.status === 200) {
            setAccountDetails(response.data);
            form.setFieldsValue({
              beneName: response.data?.customerName || undefined,
            });
            if (CONFIG?.CROSS_CURRENCY === false) {
              setTxnCurrencyList([selectedAccount?.accountCurrency]);
            } else if (
              response.data?.accCcy === selectedAccount?.accountCurrency
            ) {
              setTxnCurrencyList([selectedAccount?.accountCurrency]);
            } else {
              setTxnCurrencyList([
                selectedAccount?.accountCurrency,
                response.data?.accCcy,
              ]);
            }
          }
        }
      } catch (error) {
        setAccountDetails({});
      }
    },
    [selectedAccount, CONFIG]
  );

  const getConvertedAmount = useCallback(async () => {
    try {
      if (CONFIG?.CROSS_CURRENCY === false) {
        return;
      }
      const { amount, txnCcy, fxDealRefNo } = form.getFieldsValue();
      setSelectedTxnCcy(txnCcy);
      const transferAmount =
        typeof amount === "number"
          ? amount
          : parseFloat(amount.replaceAll(/,/g, ""));
      const reqParams = {
        srcCcy: selectedAccount?.accountCurrency,
        destCcy: accountDetails?.accCcy || CONFIG.CURRENCY,
        txnCcy: txnCcy,
        txnType: "OAT",
        amount: transferAmount,
        fxDealRefNo: fxDealRefNo,
        srcAcct: selectedAccount?.accountNo,
        accountName: selectedAccount?.accountName,
        srcAccName: selectedAccount?.accountName,
      };
      if (txnCcy === selectedAccount?.accountCurrency) {
        return;
      }
      const response = await TransferService.getConvertedAmount(reqParams);
      if (response.status === 200) {
        setConvertedAmount(response.data["data"]);
      }
    } catch (error) {}
  }, [selectedAccount, accountDetails]);

  const handleDownload = useCallback(async (selected) => {
    try {
      const reqParams = {
        txnId: selected?.txnId,
      };
      setSuccessVisible(false);

      await PendingAuthService.downloadReceipts(reqParams);
      navigate("/transfer");
    } catch (err) {}
  }, []);

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderForm();

      case 2:
        return renderConfirm();

      case 3:
        return (
          <CommonOtp
            otp={otp}
            setOtp={setOtp}
            type="TRANSACTION"
            onConfirm={(values) =>
              fundTransferConfirm({ ...formDetails, ...values })
            }
            handleResendOtp={() => fundTransferVerify()}
            cancelTransaction={() => {
              navigate("/transfer");
            }}
          />
        );

      default:
        return renderForm();
    }
  }

  function renderForm() {
    return (
      <>
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <p>
            {t("pages.fundtransfer.transfer_desc", {
              defaultValue: "Please enter below details",
            })}
          </p>
          <div className="row">
            <div className="d-flex align-items-center">
              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <AccountDisplay type="image" />
              </div>
            </div>
          </div>
          <Form
            layout="vertical"
            requiredMark={true}
            form={form}
            onFinish={onVerify}
            initialValues={formDetails}
          >
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <Form.Item
                  label={t("pages.standing_instruction.bene_acc_no", {
                    defaultValue: "Beneficiary Account Number",
                  })}
                  name="destAcctNo"
                  rules={[
                    {
                      required: true,
                      message: t(
                        "pages.standing_instruction.bene_acc_no_req_txt",
                        {
                          defaultValue:
                            "Beneficiary Account Number is required",
                        }
                      ),
                    },
                    {
                      min: CONFIG?.ACCOUNT_NO_MIN_LENGTH,
                      max: CONFIG?.ACCOUNT_NUMBER_MAX_LENGTH,
                      message: t(
                        "pages.standing_instruction.enter_valid_acc_txt",
                        {
                          defaultValue:
                            "Please enter valid Beneficiary Account Number",
                        }
                      ),
                    },
                  ]}
                >
                  <Input
                    autoComplete="off"
                    maxLength={CONFIG?.ACCOUNT_NUMBER_MAX_LENGTH}
                    onKeyPress={(e) => allowOnlyNumbers(e)}
                    onPaste={(e) => handlePasteNotAllowSpace(e)}
                    placeholder={t("pages.standing_instruction.bene_acc_no", {
                      defaultValue: "Beneficiary Account Number",
                    })}
                    onBlur={(e) => {
                      accountLookUp(e.target.value);
                    }}
                    tabIndex={1}
                    size="large"
                  />
                </Form.Item>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <Form.Item
                  label={t("pages.Add_Bene.bane_name", {
                    defaultValue: "Beneficiary Name",
                  })}
                  name={"beneName"}
                  rules={[
                    {
                      required: false,
                      message: t("pages.Add_Bene.bene_name_req", {
                        defaultValue: "Beneficiary Name is required",
                      }),
                    },
                  ]}
                >
                  <Input
                    autoComplete="off"
                    readOnly={true}
                    onKeyPress={(e) => allowOnlyAlphabetsWithSpace(e)}
                    maxLength={50}
                    placeholder={t("pages.Add_Bene.bane_name", {
                      defaultValue: "Beneficiary Name",
                    })}
                    tabIndex={2}
                    size="large"
                  />
                </Form.Item>
              </div>
              <div
                className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
                style={{ position: "relative" }}
              >
                <Form.Item
                  label={t("pages.fundtransfer.transaction_curr", {
                    defaultValue: "Transaction Currency",
                  })}
                  name={"txnCcy"}
                  rules={[
                    {
                      required: txnCurrencyList.length <= 1 ? false : true,
                      message: t("errorMesssages.trans_currency_require", {
                        defaultValue: "Transaction Currency is required",
                      }),
                    },
                  ]}
                >
                  {txnCurrencyList.length <= 1 ? (
                    <Input readOnly size="large" />
                  ) : (
                    <Select
                      placeholder={t("pages.fundtransfer.transaction_curr", {
                        defaultValue: "Transaction Currency",
                      })}
                      bordered={true}
                      size="large"
                      optionFilterProp="children"
                      showSearch
                      onChange={(e) => {
                        form.setFieldsValue({ amount: "" });
                        setConvertedAmount({});
                      }}
                    >
                      {txnCurrencyList.map((option, idx) => (
                        <Select.Option key={idx} value={option}>
                          {option}
                        </Select.Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <Form.Item
                  label={t("common.amount", {
                    defaultValue: "Amount",
                  })}
                  name={"amount"}
                  rules={[
                    {
                      required: true,
                      message: t("errorMesssages.amount_required", {
                        defaultValue: "Amount is required",
                      }),
                    },
                    {
                      validator: (_, value) => {
                        if (parseFloat(value) <= 0) {
                          return Promise.reject(
                            t("errorMesssages.amount_valid", {
                              defaultValue: "Amount should be greater than 0",
                            })
                          );
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <NumericFormat
                    type="tel"
                    placeholder={t("common.amount", {
                      defaultValue: "Amount",
                    })}
                    maxLength={12}
                    allowNegative={false}
                    customInput={Input}
                    thousandSeparator={true}
                    fixedDecimalScale={false}
                    onKeyPress={(e) => allowDecimalwithMaxLimit(e)}
                    onBlur={(e) => {
                      e.target.value.length > 0 && getConvertedAmount();
                    }}
                    onChange={() => setConvertedAmount({})}
                    size="large"
                  />
                </Form.Item>

                {Object.keys(convertedAmount).length !== 0 && (
                  <div className="row mb-2">
                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                      <label className="mb-1">
                        {convertedAmount?.prefferedRate === true
                          ? t(
                              "pages.sendMoney.common_sendMoney.preffered_rate",
                              {
                                defaultValue: "Preffered Rate",
                              }
                            )
                          : t(
                              "pages.sendMoney.common_sendMoney.exchange_rate",
                              {
                                defaultValue: "Exchange Rate",
                              }
                            )}
                      </label>{" "}
                      <br />
                      <span>
                        1 {selectedAccount?.accountCurrency} ={" "}
                        {selectedTxnCcy + " " + convertedAmount.convRate}
                      </span>
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                      <label className="mb-1">
                        {" "}
                        {t("pages.sendMoney.common_sendMoney.deducted_amount", {
                          defaultValue: "Deducted Amount",
                        })}
                      </label>
                      <br />
                      <span>{convertedAmount.deductedAmt}</span>
                    </div>
                  </div>
                )}
              </div>
              {CONFIG?.PAYMENT_OPTION && (
                <>
                  <span
                    className="d-block mb-3 "
                    style={{ textAlign: "left", cursor: "pointer" }}
                  >
                    {t("pages.fundtransfer.payment_options", {
                      defaultValue: "Payment Options",
                    })}
                  </span>
                  <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-5 col-xl-5">
                      <Form.Item
                        label=""
                        name={"paymentType"}
                        style={
                          paymentType === "RECURRING"
                            ? { marginBottom: 20 }
                            : { marginBottom: 5 }
                        }
                      >
                        <Radio.Group
                          onChange={(e) => setPaymentType(e.target.value)}
                        >
                          <Radio value={"ONCE"} tabIndex={5}>
                            One Time
                          </Radio>
                          <Radio value={"RECURRING"} tabIndex={6}>
                            Recurring
                          </Radio>
                        </Radio.Group>
                      </Form.Item>
                      {paymentType === "ONCE" && (
                        <Form.Item label="" name={"paymentSubType"}>
                          <Radio.Group
                            onChange={(e) => setPaymentSubType(e.target.value)}
                          >
                            <Radio value={"Pay_Now"} tabIndex={7}>
                              Pay Now
                            </Radio>
                            <Radio value={"Pay_Later"} tabIndex={8}>
                              Pay Later
                            </Radio>
                          </Radio.Group>
                        </Form.Item>
                      )}
                    </div>
                  </div>
                </>
              )}
              {paymentType === "ONCE" && paymentSubType === "Pay_Later" && (
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                  <Form.Item
                    label={t("pages.sendMoney.common_sendMoney.date", {
                      defaultValue: "Date",
                    })}
                    name={"frequencyDate"}
                    style={{ width: "100%" }}
                    rules={[
                      {
                        required: true,
                        message: t("errorMesssages.date_require", {
                          defaultValue: "Date is required",
                        }),
                      },
                    ]}
                  >
                    <DatePicker
                      // inputReadOnly={true}
                      allowClear={false}
                      showToday={false}
                      disabledDate={(current) => {
                        return (
                          dayjs().add(0, "days") >= current ||
                          dayjs().add(1, "month") <= current
                        );
                      }}
                      placeholder="DD-MM-YYYY"
                      // format={"DD-MM-YYYY"}
                      format={{
                        format: "DD-MM-YYYY",
                        type: "mask",
                      }}
                      tabIndex={9}
                      size="large"
                    />
                  </Form.Item>
                </div>
              )}

              {paymentType === "RECURRING" && (
                <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                  <Form.Item
                    label={t("pages.fundtransfer.no_of_instal", {
                      defaultValue: "Number of installment",
                    })}
                    name={"numberOfInstallment"}
                    rules={[
                      {
                        required: true,
                        message: t("errorMesssages.no_insdtall_require", {
                          defaultValue: "Number of installment is required",
                        }),
                      },
                    ]}
                  >
                    <Select
                      placeholder={t("pages.fundtransfer.no_of_instal", {
                        defaultValue: "Number of installment",
                      })}
                      bordered={true}
                      size="large"
                      tabIndex={10}
                    >
                      {metaData.maximumInstallments.map((option, idx) => (
                        <Select.Option key={idx} value={option}>
                          {option}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
              )}

              {paymentType === "RECURRING" && (
                <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                  <Form.Item
                    label={t("pages.fundtransfer.frequency", {
                      defaultValue: "Frequency",
                    })}
                    name={"frequency"}
                    rules={[
                      {
                        required: true,
                        message: t("errorMesssages.freq_requir", {
                          defaultValue: "Frequency is required",
                        }),
                      },
                    ]}
                  >
                    <Select
                      placeholder={t("pages.fundtransfer.frequency", {
                        defaultValue: "Frequency",
                      })}
                      bordered={true}
                      size="large"
                      tabIndex={11}
                    >
                      {metaData.frequency.map((option, idx) => (
                        <Select.Option key={idx} value={option}>
                          {option}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
              )}

              {paymentType === "RECURRING" && (
                <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                  <Form.Item
                    label={t("pages.common.start_date", {
                      defaultValue: "Start Date",
                    })}
                    name={"frequencyDate"}
                    style={{ width: "100%" }}
                    rules={[
                      {
                        required: true,
                        message: t("errorMesssages.start_date_require", {
                          defaultValue: "Start Date is required",
                        }),
                      },
                    ]}
                  >
                    <DatePicker
                      // inputReadOnly={true}
                      allowClear={false}
                      showToday={false}
                      disabledDate={(current) => {
                        return (
                          dayjs().add(0, "days") >= current ||
                          dayjs().add(1, "month") <= current
                        );
                      }}
                      placeholder="DD-MM-YYYY"
                      // format={"DD-MM-YYYY"}
                      format={{
                        format: "DD-MM-YYYY",
                        type: "mask",
                      }}
                      size="large"
                      tabIndex={12}
                    />
                  </Form.Item>
                </div>
              )}

              {form?.getFieldValue("txnCcy") !==
                selectedAccount?.accountCurrency && (
                <Form.Item
                  label={""}
                  name={"hasFxDeal"}
                  rules={[
                    {
                      required: true,
                      message: t("errorMesssages.has_fx_deal_require", {
                        defaultValue: "Has Fx Deal is required",
                      }),
                    },
                  ]}
                >
                  <span style={{ marginRight: "10px" }}>
                    <span className="asterisk-mark">*</span>
                    {t("pages.fundtransfer.hasfx", {
                      defaultValue: "Has Fx Deal ?",
                    })}
                  </span>
                  <Radio.Group
                    onChange={(e) => setHasFxDeal(e.target.value)}
                    value={hasFxDeal}
                  >
                    <Radio value={true} tabIndex={13}>
                      Yes
                    </Radio>
                    <Radio value={false} tabIndex={14}>
                      No
                    </Radio>
                  </Radio.Group>
                </Form.Item>
              )}

              {hasFxDeal && (
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                  <Form.Item
                    label={t("pages.fundtransfer.fxno", {
                      defaultValue: "Fx Ref Number",
                    })}
                    name={"fxDealRefNo"}
                    rules={[
                      {
                        required: true,
                        message: t("errorMesssages.fx_ref_num_require", {
                          defaultValue: "Fx Ref Number is required",
                        }),
                      },
                    ]}
                  >
                    <Input
                      autoComplete="off"
                      onKeyPress={(e) => allowOnlyAlphaNumerics(e)}
                      maxLength={30}
                      placeholder={t("pages.fundtransfer.fxno", {
                        defaultValue: "Fx Ref Number",
                      })}
                      size="large"
                      onBlur={(e) => {
                        e.target.value.length > 0 && getConvertedAmount();
                      }}
                      tabIndex={15}
                    />
                  </Form.Item>
                </div>
              )}

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <Form.Item
                  name="remarks"
                  rules={[
                    {
                      required: true,
                      message: t("errorMessages.remark_invalid", {
                        defaultValue:
                          "Reason cannot be empty or whitespace only",
                      }),
                      validator: (_, value) => {
                        if (value && value.trim() !== "") {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error("Reason cannot be empty or whitespace only")
                        );
                      },
                    },
                  ]}
                  label={t("common.remarks", {
                    defaultValue: "Reason",
                  })}
                >
                  <Input
                    autoComplete="off"
                    placeholder={t("common.remarks", {
                      defaultValue: "Reason",
                    })}
                    size="large"
                    maxLength={500}
                    tabIndex={16}
                    onKeyPress={(e) => allowOnlyAlphaNumericsWithSpace(e)}
                  />
                </Form.Item>
              </div>
            </div>

            <div className="bene-btn-group-container justify-content-end  mt-3">
              {/* <div onClick={() => setAddBene(!addBene)} className="mt-1">
                                {accountDetails?.beneExists !== true && (
                                    <>
                                        <span style={{ marginRight: "5px ", cursor: "pointer" }}>
                                            {addBene ? (
                                                <img
                                                    src={checkedIcon}
                                                    alt="checked"
                                                    width={17}
                                                    height={17}
                                                    className="checked"
                                                />
                                            ) : (
                                                <img
                                                    src={unCheckedIcon}
                                                    alt="unchecked"
                                                    width={17}
                                                    height={17}
                                                    className="unchecked"
                                                />
                                            )}
                                        </span>
                                        Add As Beneficiary
                                    </>
                                )}
                            </div> */}

              <div className="btn-group-container-style">
                <Button
                  onClick={() => navigate("/send-money")}
                  type="default"
                  className="secondary-btn"
                  style={{ marginRight: 20 }}
                  size="large"
                  tabIndex={17}
                >
                  {t("buttons.cancel_btn", {
                    defaultValue: "Cancel",
                  })}
                </Button>

                <Button
                  type="primary"
                  className="primary-btn"
                  htmlType="submit"
                  disabled={Object.keys(accountDetails).length === 0}
                  size="large"
                  tabIndex={18}
                >
                  {t("buttons.submit_btn", {
                    defaultValue: "Submit",
                  })}
                </Button>
              </div>
            </div>
          </Form>
        </div>
      </>
    );
  }

  function renderConfirm() {
    return (
      <>
        <h5 className="mb-3">
          {t("common.confirmation", {
            defaultValue: "Confirmation",
          })}
        </h5>

        <p className="mb-3" style={{ fontSize: 14 }}>
          {t("pages.sendMoney.payee.payment_txt", {
            defaultValue:
              "Please check the payment details carefully, before you proceed",
          })}
        </p>

        <div className="row">
          <div className="d-flex align-items-center">
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
              <AccountDisplayView />
            </div>
          </div>
        </div>

        <div className="confirm-details">
          <div className="row">
            <div className="confirm-label-wrapper">
              <label>
                {t("common.destination_account", {
                  defaultValue: "Destination Account",
                })}
              </label>
              <span>{formDetails?.destAcct}</span>
            </div>
            <div className="confirm-label-wrapper">
              <label>
                {t("pages.Add_Bene.bane_name", {
                  defaultValue: "Beneficiary Name",
                })}
              </label>
              <span>{formDetails?.beneName || "-"}</span>
            </div>

            <div className="confirm-label-wrapper">
              <label>
                {t("pages.payment_history.transfer_type", {
                  defaultValue: "Transfer Type",
                })}
              </label>
              <span>
                {formDetails?.txnType === "OAT" &&
                  t("pages.sendMoney.common_sendMoney.own_account_transfer", {
                    defaultValue: "Own Account Transfer",
                  })}
              </span>
            </div>

            {accountDetails?.beneExists !== true && (
              <div className="confirm-label-wrapper">
                <label>Add As Beneficiary</label>
                <span>
                  {formDetails?.addBene
                    ? t("buttons.yes_btn", {
                        defaultValue: "Yes",
                      })
                    : t("buttons.no_btn", {
                        defaultValue: "No",
                      })}
                </span>
              </div>
            )}

            <div className="confirm-label-wrapper">
              <label>
                {t("pages.fundtransfer.transaction_curr", {
                  defaultValue: "Transaction Currency",
                })}
              </label>
              <span>{formDetails?.txnCcy}</span>
            </div>

            <div className="confirm-label-wrapper">
              <label>
                {t("common.amount", {
                  defaultValue: "Amount",
                })}
              </label>
              <span>{amountFormat(formDetails?.amount, selectedTxnCcy)}</span>
            </div>

            {Object.keys(convertedAmount).length !== 0 ? (
              <>
                <div className="confirm-label-wrapper">
                  <label>
                    {" "}
                    {t("pages.sendMoney.common_sendMoney.deducted_amount", {
                      defaultValue: "Deducted Amount",
                    })}
                  </label>
                  <span>{convertedAmount.deductedAmt}</span>
                </div>
              </>
            ) : null}

            {CONFIG?.PAYMENT_OPTION && (
              <div className="confirm-label-wrapper">
                <label>
                  {t("pages.view_scheduled_transfer.payment_type", {
                    defaultValue: "Payment Type",
                  })}
                </label>
                <span>
                  {metaData.paymentTypes[formDetails?.paymentType] ||
                    formDetails?.paymentType}
                </span>
              </div>
            )}

            {paymentType === "RECURRING" ? (
              <div className="confirm-label-wrapper">
                <label>
                  {t("pages.fundtransfer.no_of_instal", {
                    defaultValue: "Number of installment",
                  })}
                </label>
                <span>{formDetails?.numberOfInstallments || "-"}</span>
              </div>
            ) : null}

            {paymentType === "RECURRING" ? (
              <div className="confirm-label-wrapper">
                <label>
                  {t("pages.fundtransfer.frequency", {
                    defaultValue: "Frequency",
                  })}
                </label>
                <span>{formDetails?.frequency}</span>
              </div>
            ) : null}

            <div className="confirm-label-wrapper">
              <label>
                {t("pages.sendMoney.common_sendMoney.date", {
                  defaultValue: "Date",
                })}
              </label>
              {paymentType === "ONCE" && paymentSubType === "Pay_Now" && (
                <span>{dayjs().format("DD-MM-YYYY")}</span>
              )}
              {paymentType === "ONCE" && paymentSubType === "Pay_Later" && (
                <span>
                  {dayjs(formDetails?.scheduledDate).format("DD-MM-YYYY")}
                </span>
              )}

              {paymentType === "RECURRING" && (
                <span>
                  {dayjs(formDetails?.scheduledDate).format("DD-MM-YYYY")}
                </span>
              )}
            </div>

            {hasFxDeal ? (
              <>
                <div className="confirm-label-wrapper">
                  <label>
                    {t("pages.fundtransfer.fxno", {
                      defaultValue: "Fx Ref Number",
                    })}
                  </label>
                  <span>{formDetails?.fxDealRefNo}</span>
                </div>
              </>
            ) : null}

            <div className="confirm-label-wrapper">
              <label>
                {t("pages.service_request.common_service.charges", {
                  defaultValue: "Charges",
                })}
              </label>
              <span>{amountFormat(chargesList.charges, selectedTxnCcy)}</span>
            </div>

            <div className="confirm-label-wrapper">
              <label>
                {t("common.remarks", {
                  defaultValue: "Reason",
                })}
              </label>
              <span>{formDetails?.remarksTag || "-"}</span>
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-end mt-4">
          {/* <Button
              onClick={() => setCancelVisible(true)}
              type="default"
              style={{ marginRight: 30 }}
              className="secondary-btn"
              size="large"
            >
              {t("buttons.cancel_btn", {
                defaultValue: "Cancel",
              })}
            </Button> */}

          <Button
            onClick={() => setStage(1)}
            type="default"
            className="secondary-btn mx-3"
            size="large"
          >
            {t("buttons.back_btn", {
              defaultValue: "Back",
            })}
          </Button>
          <Button
            onClick={() => fundTransferVerify()}
            type="primary"
            className="primary-btn"
            size="large"
          >
            {t("buttons.proceed_btn", {
              defaultValue: "Proceed",
            })}
          </Button>
        </div>
      </>
    );
  }

  return (
    <>
      <Card size="small" className="mb-2 breadcrumb-card hide-xs">
        <Breadcrumb separator=">">
          <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              {t("navigation.home", {
                defaultValue: "Home",
              })}
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span onClick={() => navigate("/transfer")}>
              {t("navigation.transfer", {
                defaultValue: "Transfers",
              })}
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span onClick={() => navigate("/send-money/quick-pay")}>
              {t("pages.sendMoney.payee.quick_transfer", {
                defaultValue: "Quick Transfer",
              })}
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>
              {t("navigation.own_transfer", {
                defaultValue: "Own Transfer",
              })}
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>
      </Card>
      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <div className="d-flex" style={{ height: "25px" }}>
              <p className="title title-header hide-xs">
                {t("pages.sendMoney.payee.quick_transfer", {
                  defaultValue: "Quick Transfer",
                })}{" "}
              </p>
              <p className="Pipe hide-xs">|</p>
              <p className="beneTitle">
                {t("navigation.own_transfer", {
                  defaultValue: "Own Transfer",
                })}
              </p>
            </div>
          </div>
        </div>
      </Card>

      <div className="row d-flex justify-content-between">
        {stage === 1 ? (
          <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 hide-xs">
            <Card className="application-card" style={{ marginRight: "-2.5%" }}>
              <AccountCard />
            </Card>
          </div>
        ) : (
          <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 hide-xs">
            <Card className="application-card" style={{ marginRight: "-2.5%" }}>
              <AccountSelectedCard />
            </Card>
          </div>
        )}
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
          <Card className="application-card card-padding">
            {renderSwitch()}
          </Card>
        </div>
      </div>

      <Modal
        title={t("pages.sendMoney.payee.quick_transfer", {
          defaultValue: "Cancel transfer?",
        })}
        open={cancelVisible}
        footer={null}
        width={350}
        closable={false}
        maskClosable={false}
        mask={true}
      >
        <p style={{ marginBottom: 30, fontSize: 15 }}>
          {t("pages.otp.quitCancelTitle", {
            defaultValue:
              " If you cancel this transaction now, you will have to start over. Are you sure you want to cancel?",
          })}
        </p>
        <div className="mt-3" align="right">
          <Button
            className="secondary-btn"
            type="default"
            onClick={() => setCancelVisible(false)}
          >
            {t("buttons.no_btn", {
              defaultValue: "No",
            })}
          </Button>
          <Button
            type="primary"
            className="primary-btn"
            style={{ marginLeft: 20 }}
            onClick={() => {
              setCancelVisible(false);
              navigate("/transfer");
            }}
          >
            {t("buttons.yes_btn", {
              defaultValue: "Yes",
            })}
          </Button>
        </div>
      </Modal>

      <Modal
        title={""}
        open={successVisible}
        footer={null}
        width={480}
        closable={false}
        maskClosable={false}
        mask={true}
      >
        <div style={{ margin: "0 auto" }} align="center">
          <TickIcon height={65} />
          <h4 className="mb-3 mt-2">
            {t("common.success", {
              defaultValue: "Success",
            })}
          </h4>
          <p>{respDetails?.message}</p>
          <div align="center" className="d-flex justify-content-center">
            <Button
              size="large"
              style={{ width: 130 }}
              onClick={() => {
                setSuccessVisible(false);
                navigate("/transfer");
                fetchAccounts();
              }}
              type="primary"
            >
              {t("buttons.okay_btn", {
                defaultValue: "Okay",
              })}
            </Button>
            {mode === "AA" &&
              paymentType === "ONCE" &&
              paymentSubType === "Pay_Now" && (
                <>
                  <Button
                    size="large"
                    onClick={() => {
                      handleDownload(respDetails);
                      fetchAccounts();
                    }}
                    className="secondary-btn mx-4"
                  >
                    {t("buttons.download_btn", { defaultValue: "Download" })}
                  </Button>
                </>
              )}
          </div>
        </div>
      </Modal>

      <Modal
        open={isErrorModalVisible}
        footer={null}
        width={480}
        closable={false}
        maskClosable={false}
        mask={true}
        className="custom-error-modal"
      >
        <div style={{ margin: "0 auto" }} align="center">
          <VscError
            style={{ display: "block", margin: "10px 0" }}
            size={50}
            fill="#ff4d4f"
          />
          <h5 className="mb-3" style={{ color: "#ff4d4f" }}>
            Alert!
          </h5>
          <p style={{ marginBottom: 30, fontSize: 15 }}>
            Cross currency transactions are not allowed at this time.
          </p>
          <div align="center">
            <Button
              onClick={() => {
                setIsErrorModalVisible(false);
              }}
              type="primary"
              size="large"
            >
              {t("buttons.close_btn", { defaultValue: "Close" })}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
}
